import { render, staticRenderFns } from "./notCompeleteSupervision.vue?vue&type=template&id=c22ce550&scoped=true"
import script from "./notCompeleteSupervision.vue?vue&type=script&lang=js"
export * from "./notCompeleteSupervision.vue?vue&type=script&lang=js"
import style0 from "./notCompeleteSupervision.vue?vue&type=style&index=0&id=c22ce550&prod&lang=scss&scoped=true"
import style1 from "./notCompeleteSupervision.vue?vue&type=style&index=1&id=c22ce550&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22ce550",
  null
  
)

export default component.exports